import { render, staticRenderFns } from "./YearHomeBought.vue?vue&type=template&id=6e4ab229&"
import script from "./YearHomeBought.vue?vue&type=script&lang=js&"
export * from "./YearHomeBought.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports